module.exports = __webpack_public_path__ + "img/9788949120898.6b07bfa9.jpg";